import { Button } from 'antd';
import { useSalesforceAuth } from '@hooks';
import { FULL_ROUTES, QUERY, SETTINGS_ORGANIZATION_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
function getRedirectState(organizationId) {
    const current = new URL(window.location.href);
    current.searchParams.append(QUERY.ORGANIZATION, String(organizationId));
    return current.toString();
}
export const ReauthenticationButton = ({ organization }) => {
    const redirectState = useMemo(() => getRedirectState(organization.id), [organization.id]);
    const { authRedirect, sandboxAuthRedirect } = useSalesforceAuth(FULL_ROUTES.INTEGRATIONS_SALESFORCE, redirectState);
    const handler = organization.isSandbox ? sandboxAuthRedirect : authRedirect;
    return React.createElement(Button, { onClick: handler }, SETTINGS_ORGANIZATION_COPY.REAUTHORIZE);
};
